import { render, staticRenderFns } from "./UsersubgroupAttMonitoringDash.vue?vue&type=template&id=a3f0bf64"
import script from "./UsersubgroupAttMonitoringDash.vue?vue&type=script&lang=js"
export * from "./UsersubgroupAttMonitoringDash.vue?vue&type=script&lang=js"
import style0 from "./UsersubgroupAttMonitoringDash.vue?vue&type=style&index=0&id=a3f0bf64&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports